import { useState } from "react";

import { isPresent } from "neetocist";
import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
// eslint-disable-next-line @bigbinary/neeto/prefix-neeto-ui-import-alias
import { ExternalLink, Link as LinkIcon } from "neetoicons";
import { Button } from "neetoui";
import { useTranslation } from "react-i18next";

import CopyToClipboardButton from "components/CopyToClipboardButton";
import MoreDropdown from "components/MoreDropdown";

import EditURL from "./EditURL";
import RegenerateURL from "./RegenerateURL";

const Link = ({
  editUrlProps,
  enabledOptions,
  entityName,
  handleEdit,
  handleRegenerate,
  isLoading,
  previewUrl,
  url,
}) => {
  const [isRegenerateURLModalOpen, setIsRegenerateURLModalOpen] =
    useState(false);
  const [isEditURLModalOpen, setIsEditURLModalOpen] = useState(false);

  const { t } = useTranslation();

  const { isSize } = useBreakpoints();
  const isMobile = isSize("mobile");

  const isDropdownEnabled = enabledOptions.regenerate || enabledOptions.edit;

  return (
    <div className="flex flex-col gap-y-4" data-testid="link-block">
      <div className="flex items-center gap-1 sm:gap-2">
        <div
          className="relative flex min-w-0 flex-grow items-stretch truncate leading-none"
          data-testid="nui-input-field"
        >
          <div className="neeto-ui-rounded-md neeto-ui-border-gray-300 neeto-ui-bg-gray-50 relative flex min-w-0 flex-grow items-center truncate rounded-r-none border leading-none rtl:rounded-l-none rtl:rounded-r-md">
            <Button
              className="neeto-molecules-share-link-button relative min-w-0 flex-grow flex-row truncate px-2 py-1 leading-none"
              href={url}
              icon={LinkIcon}
              iconPosition="left"
              label={url}
              style="link"
              target="_blank"
            />
          </div>
          <CopyToClipboardButton
            className="rounded-l-none rtl:rounded-l-md rtl:rounded-r-none"
            data-testid="link-copy-button"
            label={!isMobile ? t("neetoMolecules.shareViaLink.copyLink") : null}
            value={url}
          />
        </div>
        <div className="flex flex-shrink-0 items-center gap-1 sm:gap-2">
          <Button
            data-testid="preview-button"
            href={previewUrl || url}
            icon={ExternalLink}
            style="secondary"
            target="_blank"
            tooltipProps={{
              content: t("neetoMolecules.shareViaLink.view", {
                entity: entityName,
              }),
              position: "top",
              touch: ["hold", 500],
            }}
          />
          {isDropdownEnabled && (
            <>
              <MoreDropdown
                menuItems={[
                  {
                    isVisible:
                      enabledOptions.regenerate ||
                      isPresent(enabledOptions.regenerate),
                    "data-testid": "regenerate-url-button",
                    onClick: () => setIsRegenerateURLModalOpen(true),
                    label: t("neetoMolecules.shareViaLink.regenerateUrl.title"),
                    key: "regenerate-url-option",
                  },
                  {
                    isVisible: enabledOptions.edit,
                    "data-testid": "edit-url-button",
                    onClick: () => setIsEditURLModalOpen(true),
                    label: t("neetoMolecules.shareViaLink.editUrl.title"),
                    key: "edit-url-option",
                  },
                ]}
              />
              <RegenerateURL
                {...{ handleRegenerate, isLoading, url }}
                isOpen={isRegenerateURLModalOpen}
                regenerateConfig={enabledOptions.regenerate}
                onClose={() => setIsRegenerateURLModalOpen(false)}
              />
              <EditURL
                {...{ editUrlProps, handleEdit, isLoading, url }}
                isOpen={isEditURLModalOpen}
                onClose={() => setIsEditURLModalOpen(false)}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Link;
